import fs from 'file-saver'
import { forEach } from 'jszip';
import * as XLSX from 'xlsx';

/**
 * 导出Excel文件
 * @param dataSource 需要导出的数据源
 * @param mapObj 映射对象
 * @param fileName 文件名
 * @param autoWidth 宽度自适配
 * @returns {*}
 */
export function exportFileExcel(dataSource, mapObj, fileName, autoWidth = true,merges=[]) {

    if (!dataSource || !dataSource.length) {
        this.$message.warning('没有要导出的数据');
        return
    }
    // 深拷贝对象
    let dataSource2 = JSON.parse(JSON.stringify(dataSource))
    dataSource2.forEach(item => {
        for (let i in item) {
            if (mapObj.hasOwnProperty(i)) {
                item[mapObj[i]] = item[i];
            }
            delete item[i]; //删除原先的对象属性
        }
    })
    let sheetName = fileName // excel的文件名称
    let wb = XLSX.utils.book_new()  // 工作簿对象包含一SheetNames数组，以及一个表对象映射表名称到表对象。XLSX.utils.book_new实用函数创建一个新的工作簿对象。
    let ws = XLSX.utils.json_to_sheet(dataSource2, { header: Object.values(mapObj) }) // 将JS对象数组转换为工作表。
    if(Array.isArray(merges)&&merges.length)
    {
       ws['!merges']=merges
    }
    wb.SheetNames.push(sheetName)
    wb.Sheets[sheetName] = ws
    const defaultCellStyle = { font: { name: "Verdana", sz: 13, color: "FF00FF88" }, fill: { fgColor: { rgb: "FFFFAA00" } } }; // 设置表格的样式
    let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary', autoWidth: true, cellStyles: true, defaultCellStyle: defaultCellStyle, showGridLines: false }  //写入的样式
    // let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary', }  //写入的样式
    console.log('dataSource2 = ', dataSource2)
    if (autoWidth) AutoWidth(ws, dataSource, mapObj)
    let wbout = XLSX.write(wb, wopts)
    let blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
    fs.saveAs(blob, fileName + '.xlsx')
}


// 自动宽度计算
function AutoWidth(ws, arr, mapObj) {

    // 设置worksheet每列的最大宽度
    const colWidth = arr.map(row =>
        Object.keys(mapObj).map(key => {
            let val = row[key]
            if (val == null) {
                return { wch: 10 }
            } else if (/.*[\u4e00-\u9fa5]+.*$/.test(val)) {
                const cLength = val.match(/[\u4e00-\u9fa5]/g).length
                const oLength = val.length - cLength
                let wchVal = cLength * 2.39 + oLength * 1.1
                wchVal = wchVal < 10 ? 10 : wchVal
                return { wch: wchVal }
            } else {
                let wchVal = val.toString().length * 1.1
                wchVal = wchVal < 10 ? 10 : wchVal
                return { wch: wchVal }
            }
        })
    )

    // 以第一行为初始值
    const result = colWidth[0]
    for (let i = 1; i < colWidth.length; i++) {
        for (let j = 0; j < colWidth[i].length; j++) {
            if (result[j].wch < colWidth[i][j].wch) {
                result[j].wch = colWidth[i][j].wch
            }
        }
    }
    ws['!cols'] = result
}

const s2ab = s => {
    if (typeof ArrayBuffer !== 'undefined') {
        var buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
        return buf
    } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
}
